const PRINCIPAL_AND_INTEREST = 'Principal and interest'
const INTEREST_ONLY = 'Interest only'

export {
  PRINCIPAL_AND_INTEREST,
  INTEREST_ONLY
}